<template>
  <header :class="{ folded: isFolded, isHome: isHomePage }">
    <div class="brand">
      <router-link to="/">
        <span></span>
      </router-link>
    </div>
    <!-- <ul class="menu">
      <li>
        <router-link to="/about">About</router-link>
      </li>
      <li>
        <router-link to="/contact">Contact</router-link>
      </li>
    </ul> -->
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const isFolded = ref(false);
const isHomePage = ref(false);

const SCROLL_THRESHOLD = 82;

const handleScroll = () => {
  isFolded.value = window.scrollY >= SCROLL_THRESHOLD;
};

const detectHomePage = () => {
  isHomePage.value = route.path === '/';
};

onMounted(() => {
  detectHomePage();
  window.addEventListener('scroll', handleScroll);
});

watch(() => route.path, detectHomePage);

// Clean up event listener
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style lang="scss" scoped>
header {
  align-items: center;
  background: transparent;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  color: $darkGrey;
  display: grid;
  font-size: 1.1rem;
  font-weight: 400;
  grid-template-columns: 15% 85%;
  left: 0;
  padding: 2rem;
  position: fixed;
  text-transform: uppercase;
  top: 0;
  transition: all 0.4s ease-in-out;
  width: 100%;
  z-index: 2;

  &.folded {
    background: rgba(255, 255, 255, 0.8);
    padding: 1rem;

    a {
      color: $darkGrey;
    }

    @media only screen and (min-width: $tbPortrait) {
      padding: 1.5rem 3rem 1.5rem 3rem;
    }
  }

  // &.isHome {
  //   border-bottom: 1px solid white;

  //   a {
  //     color: $darkGrey;
  //   }
  // }

  a {
    color: white;

    &:hover {
      opacity: 0.4;
    }
  }

  @media only screen and (min-width: $mbLandscape) {
    // color: white;
    // grid-template-columns: 1fr 1fr;
  }

  @media only screen and (min-width: $tbPortrait) {
    padding: 3rem;
  }
}

.brand {
  display: grid;
  justify-content: start;

  span {
    align-self: center;
    background: url('../assets/images/brand.png') top center no-repeat;
    background-size: contain;
    display: block;
    justify-self: center;
    height: 3.2rem;
    width: 3.2rem;
  }

  a.router-link-active {
    opacity: 1;
  }
}

.menu {
  justify-self: end;

  li {
    &:not(:last-child) {
      padding-right: 2rem;
    }
  }
}
</style>
